import React from 'react';

const ModalTitle = ({title, fontSize, t}) => {
  return <h2 className={fontSize}>{t(title)}</h2>;
};

export default ModalTitle;
